export const assign: Record<"DISALLOW" | "ALLOW", number> = {
  // 0不可指定  1可指定
  DISALLOW: 0,
  ALLOW: 1,
};
